import { Input } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';
import { AgentExamComponent } from './agent-exam.component';

export class AgentExamHandlerComponent extends BaseComponent<AgentService> {
  constructor(agentService: AgentService) {
    super(agentService);
  }

  public onAddExamDetail(event) {
    this.service.addExamDetail();
  }
}
